import React from 'react'
import styled from 'styled-components';

export interface CrashIdBoxProps {
    crashId: string;
    companyName?: string;
}

export interface WrapperProps {
    companyName?: string;
}

const CrashIdBox = ({ crashId, companyName }: CrashIdBoxProps) => {
    return (
        <Wrapper companyName={companyName}>
            {crashId}
        </Wrapper>
    )
}

const Wrapper = styled.div<WrapperProps>`
    text-align: center;
    max-width: 85%;
    margin: auto;
    font-family: Arial;
    color: ${props => (props.companyName === "LINEAR" ? "#499640" : "#3079C9" )};
    font-weight: bold;
    padding: 15px 25px;
    border: ${props => (props.companyName === "LINEAR" ? "solid #499640 1px" : "solid #3079C9 1px" )};
    border-radius: ${props => (props.companyName === "LINEAR" && "8px" )};
    width: min-content;
    line-height: 22px;
    font-size: 17px;
`

export default CrashIdBox